(function () {
  var widgets = [];

  function findWidgets() {
    var found = [];
    document.querySelectorAll('a, button, div, span').forEach(function (el) {
      var txt = (el.textContent || '').trim();
      if (txt.length > 30 || !/contact us/i.test(txt)) return;
      var node = el;
      while (node && node !== document.body) {
        if (getComputedStyle(node).position === 'fixed') {
          if (found.indexOf(node) === -1) found.push(node);
          break;
        }
        node = node.parentElement;
      }
    });
    return found;
  }

  function update() {
    if (!widgets.length || !document.body.contains(widgets[0])) {
      widgets = findWidgets();
    }
    var drawerOpen = document.body.classList.contains('overflow-hidden');
    widgets.forEach(function (w) {
      if (drawerOpen && window.innerWidth < 1024) {
        w.style.setProperty('display', 'none', 'important');
      } else {
        w.style.removeProperty('display');
      }
    });
  }

  new MutationObserver(update).observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  var tries = 0;
  var timer = setInterval(function () {
    update();
    if (widgets.length || ++tries > 20) clearInterval(timer);
  }, 1000);

  update();
})();